export const REGION_NAMES: { [regionCode: string]: string } = {
  'HK': $localize `:Name for region HK@@7880501889618483360:Hong Kong SAR, China`,
  'TW': $localize `:Name for region TW@@8634305108618071053:Taiwan, China`,

  /* eslint-disable @angular-eslint/require-localize-metadata */
  'AF': $localize `:@@country.AF:Afghanistan`,
  'AX': $localize `:@@country.AX:\u00c5land Islands`,
  'AL': $localize `:@@country.AL:Albania`,
  'DZ': $localize `:@@country.DZ:Algeria`,
  'AS': $localize `:@@country.AS:American Samoa`,
  'AD': $localize `:@@country.AD:Andorra`,
  'AO': $localize `:@@country.AO:Angola`,
  'AI': $localize `:@@country.AI:Anguilla`,
  'AQ': $localize `:@@country.AQ:Antarctica`,
  'AG': $localize `:@@country.AG:Antigua & Barbuda`,
  'AR': $localize `:@@country.AR:Argentina`,
  'AM': $localize `:@@country.AM:Armenia`,
  'AW': $localize `:@@country.AW:Aruba`,
  'AU': $localize `:@@country.AU:Australia`,
  'AT': $localize `:@@country.AT:Austria`,
  'AZ': $localize `:@@country.AZ:Azerbaijan`,
  'BS': $localize `:@@country.BS:Bahamas`,
  'BH': $localize `:@@country.BH:Bahrain`,
  'BD': $localize `:@@country.BD:Bangladesh`,
  'BB': $localize `:@@country.BB:Barbados`,
  'BY': $localize `:@@country.BY:Belarus`,
  'BE': $localize `:@@country.BE:Belgium`,
  'BZ': $localize `:@@country.BZ:Belize`,
  'BJ': $localize `:@@country.BJ:Benin`,
  'BM': $localize `:@@country.BM:Bermuda`,
  'BT': $localize `:@@country.BT:Bhutan`,
  'BO': $localize `:@@country.BO:Bolivia`,
  'BA': $localize `:@@country.BA:Bosnia & Herzegovina`,
  'BW': $localize `:@@country.BW:Botswana`,
  'BV': $localize `:@@country.BV:Bouvet Island`,
  'BR': $localize `:@@country.BR:Brazil`,
  'IO': $localize `:@@country.IO:British Indian Ocean Territory`,
  'VG': $localize `:@@country.VG:British Virgin Islands`,
  'BN': $localize `:@@country.BN:Brunei`,
  'BG': $localize `:@@country.BG:Bulgaria`,
  'BF': $localize `:@@country.BF:Burkina Faso`,
  'BI': $localize `:@@country.BI:Burundi`,
  'KH': $localize `:@@country.KH:Cambodia`,
  'CM': $localize `:@@country.CM:Cameroon`,
  'CA': $localize `:@@country.CA:Canada`,
  'CV': $localize `:@@country.CV:Cape Verde`,
  'BQ': $localize `:@@country.BQ:Caribbean Netherlands`,
  'KY': $localize `:@@country.KY:Cayman Islands`,
  'CF': $localize `:@@country.CF:Central African Republic`,
  'TD': $localize `:@@country.TD:Chad`,
  'CL': $localize `:@@country.CL:Chile`,
  'CN': $localize `:@@country.CN:China`,
  'CX': $localize `:@@country.CX:Christmas Island`,
  'CC': $localize `:@@country.CC:Cocos (Keeling) Islands`,
  'CO': $localize `:@@country.CO:Colombia`,
  'KM': $localize `:@@country.KM:Comoros`,
  'CG': $localize `:@@country.CG:Congo - Brazzaville`,
  'CD': $localize `:@@country.CD:Congo - Kinshasa`,
  'CK': $localize `:@@country.CK:Cook Islands`,
  'CR': $localize `:@@country.CR:Costa Rica`,
  'CI': $localize `:@@country.CI:C\u00f4te d\u2019Ivoire`,
  'HR': $localize `:@@country.HR:Croatia`,
  'CU': $localize `:@@country.CU:Cuba`,
  'CW': $localize `:@@country.CW:Cura\u00e7ao`,
  'CY': $localize `:@@country.CY:Cyprus`,
  'CZ': $localize `:@@country.CZ:Czech Republic`,
  'DK': $localize `:@@country.DK:Denmark`,
  'DJ': $localize `:@@country.DJ:Djibouti`,
  'DM': $localize `:@@country.DM:Dominica`,
  'DO': $localize `:@@country.DO:Dominican Republic`,
  'EC': $localize `:@@country.EC:Ecuador`,
  'EG': $localize `:@@country.EG:Egypt`,
  'SV': $localize `:@@country.SV:El Salvador`,
  'GQ': $localize `:@@country.GQ:Equatorial Guinea`,
  'ER': $localize `:@@country.ER:Eritrea`,
  'EE': $localize `:@@country.EE:Estonia`,
  'SZ': $localize `:@@country.SZ:Eswatini`,
  'ET': $localize `:@@country.ET:Ethiopia`,
  'FK': $localize `:@@country.FK:Falkland Islands`,
  'FO': $localize `:@@country.FO:Faroe Islands`,
  'FJ': $localize `:@@country.FJ:Fiji`,
  'FI': $localize `:@@country.FI:Finland`,
  'FR': $localize `:@@country.FR:France`,
  'GF': $localize `:@@country.GF:French Guiana`,
  'PF': $localize `:@@country.PF:French Polynesia`,
  'TF': $localize `:@@country.TF:French Southern Territories`,
  'GA': $localize `:@@country.GA:Gabon`,
  'GM': $localize `:@@country.GM:Gambia`,
  'GE': $localize `:@@country.GE:Georgia`,
  'DE': $localize `:@@country.DE:Germany`,
  'GH': $localize `:@@country.GH:Ghana`,
  'GI': $localize `:@@country.GI:Gibraltar`,
  'GR': $localize `:@@country.GR:Greece`,
  'GL': $localize `:@@country.GL:Greenland`,
  'GD': $localize `:@@country.GD:Grenada`,
  'GP': $localize `:@@country.GP:Guadeloupe`,
  'GU': $localize `:@@country.GU:Guam`,
  'GT': $localize `:@@country.GT:Guatemala`,
  'GG': $localize `:@@country.GG:Guernsey`,
  'GN': $localize `:@@country.GN:Guinea`,
  'GW': $localize `:@@country.GW:Guinea-Bissau`,
  'GY': $localize `:@@country.GY:Guyana`,
  'HT': $localize `:@@country.HT:Haiti`,
  'HM': $localize `:@@country.HM:Heard & McDonald Islands`,
  'HN': $localize `:@@country.HN:Honduras`,
  //'HK': $localize `:@@country.HK:Hong Kong SAR China`,
  'HU': $localize `:@@country.HU:Hungary`,
  'IS': $localize `:@@country.IS:Iceland`,
  'IN': $localize `:@@country.IN:India`,
  'ID': $localize `:@@country.ID:Indonesia`,
  'IR': $localize `:@@country.IR:Iran`,
  'IQ': $localize `:@@country.IQ:Iraq`,
  'IE': $localize `:@@country.IE:Ireland`,
  'IM': $localize `:@@country.IM:Isle of Man`,
  'IL': $localize `:@@country.IL:Israel`,
  'IT': $localize `:@@country.IT:Italy`,
  'JM': $localize `:@@country.JM:Jamaica`,
  'JP': $localize `:@@country.JP:Japan`,
  'JE': $localize `:@@country.JE:Jersey`,
  'JO': $localize `:@@country.JO:Jordan`,
  'KZ': $localize `:@@country.KZ:Kazakhstan`,
  'KE': $localize `:@@country.KE:Kenya`,
  'KI': $localize `:@@country.KI:Kiribati`,
  'KW': $localize `:@@country.KW:Kuwait`,
  'KG': $localize `:@@country.KG:Kyrgyzstan`,
  'LA': $localize `:@@country.LA:Laos`,
  'LV': $localize `:@@country.LV:Latvia`,
  'LB': $localize `:@@country.LB:Lebanon`,
  'LS': $localize `:@@country.LS:Lesotho`,
  'LR': $localize `:@@country.LR:Liberia`,
  'LY': $localize `:@@country.LY:Libya`,
  'LI': $localize `:@@country.LI:Liechtenstein`,
  'LT': $localize `:@@country.LT:Lithuania`,
  'LU': $localize `:@@country.LU:Luxembourg`,
  'MO': $localize `:@@country.MO:Macao SAR China`,
  'MG': $localize `:@@country.MG:Madagascar`,
  'MW': $localize `:@@country.MW:Malawi`,
  'MY': $localize `:@@country.MY:Malaysia`,
  'MV': $localize `:@@country.MV:Maldives`,
  'ML': $localize `:@@country.ML:Mali`,
  'MT': $localize `:@@country.MT:Malta`,
  'MH': $localize `:@@country.MH:Marshall Islands`,
  'MQ': $localize `:@@country.MQ:Martinique`,
  'MR': $localize `:@@country.MR:Mauritania`,
  'MU': $localize `:@@country.MU:Mauritius`,
  'YT': $localize `:@@country.YT:Mayotte`,
  'MX': $localize `:@@country.MX:Mexico`,
  'FM': $localize `:@@country.FM:Micronesia`,
  'MD': $localize `:@@country.MD:Moldova`,
  'MC': $localize `:@@country.MC:Monaco`,
  'MN': $localize `:@@country.MN:Mongolia`,
  'ME': $localize `:@@country.ME:Montenegro`,
  'MS': $localize `:@@country.MS:Montserrat`,
  'MA': $localize `:@@country.MA:Morocco`,
  'MZ': $localize `:@@country.MZ:Mozambique`,
  'MM': $localize `:@@country.MM:Myanmar (Burma)`,
  'NA': $localize `:@@country.NA:Namibia`,
  'NR': $localize `:@@country.NR:Nauru`,
  'NP': $localize `:@@country.NP:Nepal`,
  'NL': $localize `:@@country.NL:Netherlands`,
  'NC': $localize `:@@country.NC:New Caledonia`,
  'NZ': $localize `:@@country.NZ:New Zealand`,
  'NI': $localize `:@@country.NI:Nicaragua`,
  'NE': $localize `:@@country.NE:Niger`,
  'NG': $localize `:@@country.NG:Nigeria`,
  'NU': $localize `:@@country.NU:Niue`,
  'NF': $localize `:@@country.NF:Norfolk Island`,
  'KP': $localize `:@@country.KP:North Korea`,
  'MK': $localize `:@@country.MK:North Macedonia`,
  'MP': $localize `:@@country.MP:Northern Mariana Islands`,
  'NO': $localize `:@@country.NO:Norway`,
  'OM': $localize `:@@country.OM:Oman`,
  'PK': $localize `:@@country.PK:Pakistan`,
  'PW': $localize `:@@country.PW:Palau`,
  'PS': $localize `:@@country.PS:Palestinian Territories`,
  'PA': $localize `:@@country.PA:Panama`,
  'PG': $localize `:@@country.PG:Papua New Guinea`,
  'PY': $localize `:@@country.PY:Paraguay`,
  'PE': $localize `:@@country.PE:Peru`,
  'PH': $localize `:@@country.PH:Philippines`,
  'PN': $localize `:@@country.PN:Pitcairn Islands`,
  'PL': $localize `:@@country.PL:Poland`,
  'PT': $localize `:@@country.PT:Portugal`,
  'PR': $localize `:@@country.PR:Puerto Rico`,
  'QA': $localize `:@@country.QA:Qatar`,
  'RE': $localize `:@@country.RE:R\u00e9union`,
  'RO': $localize `:@@country.RO:Romania`,
  'RU': $localize `:@@country.RU:Russia`,
  'RW': $localize `:@@country.RW:Rwanda`,
  'WS': $localize `:@@country.WS:Samoa`,
  'SM': $localize `:@@country.SM:San Marino`,
  'ST': $localize `:@@country.ST:S\u00e3o Tom\u00e9 & Pr\u00edncipe`,
  'SA': $localize `:@@country.SA:Saudi Arabia`,
  'SN': $localize `:@@country.SN:Senegal`,
  'RS': $localize `:@@country.RS:Serbia`,
  'SC': $localize `:@@country.SC:Seychelles`,
  'SL': $localize `:@@country.SL:Sierra Leone`,
  'SG': $localize `:@@country.SG:Singapore`,
  'SX': $localize `:@@country.SX:Sint Maarten`,
  'SK': $localize `:@@country.SK:Slovakia`,
  'SI': $localize `:@@country.SI:Slovenia`,
  'SB': $localize `:@@country.SB:Solomon Islands`,
  'SO': $localize `:@@country.SO:Somalia`,
  'ZA': $localize `:@@country.ZA:South Africa`,
  'GS': $localize `:@@country.GS:South Georgia & South Sandwich Islands`,
  'KR': $localize `:@@country.KR:South Korea`,
  'SS': $localize `:@@country.SS:South Sudan`,
  'ES': $localize `:@@country.ES:Spain`,
  'LK': $localize `:@@country.LK:Sri Lanka`,
  'BL': $localize `:@@country.BL:St. Barth\u00e9lemy`,
  'SH': $localize `:@@country.SH:St. Helena`,
  'KN': $localize `:@@country.KN:St. Kitts & Nevis`,
  'LC': $localize `:@@country.LC:St. Lucia`,
  'MF': $localize `:@@country.MF:St. Martin`,
  'PM': $localize `:@@country.PM:St. Pierre & Miquelon`,
  'VC': $localize `:@@country.VC:St. Vincent & Grenadines`,
  'SD': $localize `:@@country.SD:Sudan`,
  'SR': $localize `:@@country.SR:Suriname`,
  'SJ': $localize `:@@country.SJ:Svalbard & Jan Mayen`,
  'SE': $localize `:@@country.SE:Sweden`,
  'CH': $localize `:@@country.CH:Switzerland`,
  'SY': $localize `:@@country.SY:Syria`,
  //'TW': $localize `:@@country.TW:Taiwan`,
  'TJ': $localize `:@@country.TJ:Tajikistan`,
  'TZ': $localize `:@@country.TZ:Tanzania`,
  'TH': $localize `:@@country.TH:Thailand`,
  'TL': $localize `:@@country.TL:Timor-Leste`,
  'TG': $localize `:@@country.TG:Togo`,
  'TK': $localize `:@@country.TK:Tokelau`,
  'TO': $localize `:@@country.TO:Tonga`,
  'TT': $localize `:@@country.TT:Trinidad & Tobago`,
  'TN': $localize `:@@country.TN:Tunisia`,
  'TR': $localize `:@@country.TR:Turkey`,
  'TM': $localize `:@@country.TM:Turkmenistan`,
  'TC': $localize `:@@country.TC:Turks & Caicos Islands`,
  'TV': $localize `:@@country.TV:Tuvalu`,
  'UM': $localize `:@@country.UM:U.S. Outlying Islands`,
  'VI': $localize `:@@country.VI:U.S. Virgin Islands`,
  'UG': $localize `:@@country.UG:Uganda`,
  'UA': $localize `:@@country.UA:Ukraine`,
  'AE': $localize `:@@country.AE:United Arab Emirates`,
  'GB': $localize `:@@country.GB:United Kingdom`,
  'US': $localize `:@@country.US:United States`,
  'UY': $localize `:@@country.UY:Uruguay`,
  'UZ': $localize `:@@country.UZ:Uzbekistan`,
  'VU': $localize `:@@country.VU:Vanuatu`,
  'VA': $localize `:@@country.VA:Vatican City`,
  'VE': $localize `:@@country.VE:Venezuela`,
  'VN': $localize `:@@country.VN:Vietnam`,
  'WF': $localize `:@@country.WF:Wallis & Futuna`,
  'EH': $localize `:@@country.EH:Western Sahara`,
  'YE': $localize `:@@country.YE:Yemen`,
  'ZM': $localize `:@@country.ZM:Zambia`,
  'ZW': $localize `:@@country.ZW:Zimbabwe`,
  /* eslint-enable @angular-eslint/require-localize-metadata */
}
